var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 67,
    viewBox: "0 0 56 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1318 1L11.714 3.17762L9.0355 18.2442V27.785H9.28728C9.65822 30.374 10.5643 32.8573 11.9477 35.0768C13.3312 37.2964 15.1617 39.2034 17.3228 40.6766C7.76857 44.7747 1 54.2566 1 65.284H6.357C6.35267 62.0692 7.07283 58.8947 8.46398 55.9965C9.85513 53.0983 11.8815 50.5508 14.3925 48.5434V50.3005L15.1452 51.1388L25.8592 61.8528L27.785 63.693L29.7108 61.8528L40.4248 51.1388L41.1775 50.3005V48.5434C43.6885 50.5508 45.7149 53.0983 47.106 55.9965C48.4972 58.8947 49.2173 62.0692 49.213 65.284H54.57C54.57 54.2566 47.8014 44.7774 38.2472 40.6739C40.4079 39.2011 42.2383 37.2944 43.6218 35.0753C45.0052 32.8563 45.9114 30.3735 46.2827 27.785H46.5345V18.2415L43.856 3.17762L43.4382 1H12.1318ZM16.6532 6.357H38.9168L41.1775 19.1629V22.428H14.3925V19.1629L16.6532 6.357ZM25.1065 9.0355V11.714H22.428V17.071H25.1065V19.7495H30.4635V17.071H33.142V11.714H30.4635V9.0355H25.1065ZM14.6443 27.785H40.9257C40.3072 30.8125 38.6611 33.533 36.2662 35.4856C33.8713 37.4382 30.875 38.5028 27.785 38.499C24.695 38.5028 21.6987 37.4382 19.3038 35.4856C16.9089 33.533 15.2628 30.8125 14.6443 27.785ZM27.785 43.856C30.5352 43.8416 33.2627 44.3535 35.8205 45.364V48.0425L27.785 56.078L19.7495 48.0425V45.364C22.3073 44.3535 25.0348 43.8416 27.785 43.856Z",
    fill: "#73C7A9",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffBlue);
export default __webpack_public_path__ + "static/media/staff_blue.886078af39d5fc8be9317bb7d3178285.svg";
export { ForwardRef as ReactComponent };